import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons' 
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { User } from 'oidc-client';
import AppSettings from '../types/AppSettings';
import MenuItem from '../types/MenuItem';
import SubMenuItem from '../types/SubMenuItem';
import { userHasAllRoles, userHasAnyRole } from '../utils/userRoleHelpers';
import { NavDropdown } from 'react-bootstrap';
import { RouterLocation } from 'connected-react-router';
import { LocationState } from 'history';
import { CommonAppState } from '../store';
import { Dispatch } from 'redux';

type NavSecondaryProps = {
    appSettings: AppSettings;
    user: User;
    location: RouterLocation<LocationState>;
}

class NavSecondary extends React.Component<NavSecondaryProps> {

    render(){

        const pathname = this.props.location.pathname;

        return (
            <React.Fragment>
                <Navbar fixed="top" expand="lg" className="nav-secondary flex-lg-nowrap p-0 bg-white shadow d-none d-lg-flex">
                    <Nav className="mx-auto">
                    <React.Fragment>
                        {this.props.appSettings.menuItems.map((menuItem: MenuItem, menuIndex: number) => {
                            // If this menu item has a path, bail if the user doesn't have required roles to access it
                            if(menuItem.path !== undefined) {
                                var appRoute = this.props.appSettings.routes.find(x => x.path === menuItem.path);
                                if(appRoute === undefined) {
                                    console.log(`AppRoute for ${menuItem.name} not found.`)
                                    return <React.Fragment/>;
                                }

                                if(appRoute.requireAnyRoles !== undefined && !userHasAnyRole(this.props.user, appRoute.requireAnyRoles)) {
                                    return <React.Fragment/>;
                                }

                                if(appRoute.requireAllRoles !== undefined && !userHasAllRoles(this.props.user, appRoute.requireAllRoles)) {
                                    return <React.Fragment/>;
                                }    
                            }

                            // Determine whether this menu item (or any of its children) are active
                            var menuActive = false;
                            if(menuItem.path !== undefined && menuItem.path !== "/" && pathname.startsWith(menuItem.path)) {
                                menuActive = true;
                            } else if(menuItem.path !== undefined && menuItem.path === "/" && menuItem.path === pathname) {
                                menuActive = true;
                            } else if(menuItem.subMenuItems !== undefined) {
                                for(let subMenuItem of menuItem.subMenuItems) {
                                    if(pathname.startsWith(subMenuItem.path)) {
                                        menuActive = true;
                                        break;
                                    }
                                }
                            }

                            // Render the nav item as a link if there are no sub-menu items
                            if(menuItem.subMenuItems === undefined || menuItem.subMenuItems.length === 0) {
                                if(menuItem.path === undefined) {
                                    return <React.Fragment/>;
                                }

                                return (
                                    <Nav.Item key={menuIndex} className={menuActive ? "active": ""}>
                                        <Nav.Link className="text-dark mt-2" as={Link} to={menuItem.path}>
                                            <Row>
                                                <Col className="text-center">
                                                    <FontAwesomeIcon className="icons" icon={menuItem.menuIcon as IconDefinition} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="text-center mt-2 link-text">
                                                    {menuItem.name}
                                                </Col>
                                            </Row>
                                        </Nav.Link>
                                    </Nav.Item>
                                )    
                            }

                            return (
                                <Nav.Item key={menuIndex} className={menuActive ? "active": ""}>
                                    <NavDropdown 
                                        className="mt-2"
                                        id={menuItem.name.toLowerCase().replace(/\s/,"-")}
                                        title={
                                            <React.Fragment>
                                                <Row>
                                                    <Col className="text-center">
                                                        <FontAwesomeIcon className="icons" icon={menuItem.menuIcon as IconDefinition} />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className="text-center mt-2 link-text">
                                                        {menuItem.name}
                                                    </Col>
                                                </Row> 
                                            </React.Fragment>
                                        } 
                                    >
                                        {menuItem.subMenuItems.map((subMenuItem: SubMenuItem, subMenuIndex: number) => {
                                            var appRoute = this.props.appSettings.routes.find(x => x.path === subMenuItem.path);
                                            if(appRoute === undefined) {
                                                console.log(`AppRoute for ${menuItem.name} -> ${subMenuItem.name} not found.`)
                                                return <React.Fragment/>;
                                            }
                                            
                                            if(appRoute.requireAnyRoles !== undefined && !userHasAnyRole(this.props.user, appRoute.requireAnyRoles)) {
                                                return <React.Fragment/>;
                                            }

                                            if(appRoute.requireAllRoles !== undefined && !userHasAllRoles(this.props.user, appRoute.requireAllRoles)) {
                                                return <React.Fragment/>;
                                            }

                                            return (
                                                <NavDropdown.Item key={subMenuIndex} as={Link} to={subMenuItem.path}>
                                                    {subMenuItem.name}
                                                </NavDropdown.Item>
                                            )
                                        })}
                                    </NavDropdown>
                                </Nav.Item>
                            )

                        })}
                    </React.Fragment>
                    </Nav>
                </Navbar>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state: CommonAppState) {
    return {
        user: state.oidc.user,
        location: state.router.location
    };
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        dispatch,
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavSecondary);
